// @generated by protoc-gen-es v2.11.0 with parameter "target=ts"
// @generated from file gitpod/v1/identity.proto (package gitpod.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import { file_buf_validate_validate } from "../../buf/validate/validate_pb";
import { file_gitpod_tools_v1_logfields } from "../tools/v1/logfields_pb";
import { file_gitpod_tools_v1_stainless } from "../tools/v1/stainless_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file gitpod/v1/identity.proto.
 */
export const file_gitpod_v1_identity: GenFile = /*@__PURE__*/
  fileDesc("ChhnaXRwb2QvdjEvaWRlbnRpdHkucHJvdG8SCWdpdHBvZC52MSJbChFHZXRJRFRva2VuUmVxdWVzdBIaCghhdWRpZW5jZRgBIAMoCUIIukgFkgECCAESKgoHdmVyc2lvbhgCIAEoDjIZLmdpdHBvZC52MS5JRFRva2VuVmVyc2lvbiIjChJHZXRJRFRva2VuUmVzcG9uc2USDQoFdG9rZW4YASABKAkifAoHU3ViamVjdBInCgJpZBgBIAEoCUIbukgI2AEBcgOwAQGiqx4MCgpzdWJqZWN0LmlkEkgKCXByaW5jaXBhbBgCIAEoDjIULmdpdHBvZC52MS5QcmluY2lwYWxCH7pIBYIBAhABoqseEwoRc3ViamVjdC5wcmluY2lwYWwiIQofR2V0QXV0aGVudGljYXRlZElkZW50aXR5UmVxdWVzdCJ7CiBHZXRBdXRoZW50aWNhdGVkSWRlbnRpdHlSZXNwb25zZRIjCgdzdWJqZWN0GAEgASgLMhIuZ2l0cG9kLnYxLlN1YmplY3QSFwoPb3JnYW5pemF0aW9uX2lkGAIgASgJEhkKEW9yZ2FuaXphdGlvbl90aWVyGAMgASgJIi4KFEV4Y2hhbmdlVG9rZW5SZXF1ZXN0EhYKDmV4Y2hhbmdlX3Rva2VuGAEgASgJIi0KFUV4Y2hhbmdlVG9rZW5SZXNwb25zZRIUCgxhY2Nlc3NfdG9rZW4YASABKAkqZAoOSURUb2tlblZlcnNpb24SIAocSURfVE9LRU5fVkVSU0lPTl9VTlNQRUNJRklFRBAAEhcKE0lEX1RPS0VOX1ZFUlNJT05fVjEQARIXChNJRF9UT0tFTl9WRVJTSU9OX1YyEAIq4AEKCVByaW5jaXBhbBIZChVQUklOQ0lQQUxfVU5TUEVDSUZJRUQQABIVChFQUklOQ0lQQUxfQUNDT1VOVBABEhIKDlBSSU5DSVBBTF9VU0VSEAISFAoQUFJJTkNJUEFMX1JVTk5FUhADEhkKFVBSSU5DSVBBTF9FTlZJUk9OTUVOVBAEEh0KGVBSSU5DSVBBTF9TRVJWSUNFX0FDQ09VTlQQBRIcChhQUklOQ0lQQUxfUlVOTkVSX01BTkFHRVIQBiIECAcQByoZUFJJTkNJUEFMX0FHRU5UX0VYRUNVVElPTjKFAwoPSWRlbnRpdHlTZXJ2aWNlEl0KCkdldElEVG9rZW4SHC5naXRwb2QudjEuR2V0SURUb2tlblJlcXVlc3QaHS5naXRwb2QudjEuR2V0SURUb2tlblJlc3BvbnNlIhKyqx4OEgxnZXQtaWQtdG9rZW4SmAEKGEdldEF1dGhlbnRpY2F0ZWRJZGVudGl0eRIqLmdpdHBvZC52MS5HZXRBdXRoZW50aWNhdGVkSWRlbnRpdHlSZXF1ZXN0GisuZ2l0cG9kLnYxLkdldEF1dGhlbnRpY2F0ZWRJZGVudGl0eVJlc3BvbnNlIiOQAgGyqx4cEhpnZXQtYXV0aGVudGljYXRlZC1pZGVudGl0eRJoCg1FeGNoYW5nZVRva2VuEh8uZ2l0cG9kLnYxLkV4Y2hhbmdlVG9rZW5SZXF1ZXN0GiAuZ2l0cG9kLnYxLkV4Y2hhbmdlVG9rZW5SZXNwb25zZSIUsqseEBIOZXhjaGFuZ2UtdG9rZW4aDqqrHgoKCGlkZW50aXR5QixaKmdpdGh1Yi5jb20vZ2l0cG9kLWlvL2dpdHBvZC1uZXh0L2FwaS9nby92MWIGcHJvdG8z", [file_buf_validate_validate, file_gitpod_tools_v1_logfields, file_gitpod_tools_v1_stainless]);

/**
 * @generated from message gitpod.v1.GetIDTokenRequest
 */
export type GetIDTokenRequest = Message<"gitpod.v1.GetIDTokenRequest"> & {
  /**
   * @generated from field: repeated string audience = 1;
   */
  audience: string[];

  /**
   * version is the version of the ID token.
   *
   * @generated from field: gitpod.v1.IDTokenVersion version = 2;
   */
  version: IDTokenVersion;
};

/**
 * Describes the message gitpod.v1.GetIDTokenRequest.
 * Use `create(GetIDTokenRequestSchema)` to create a new message.
 */
export const GetIDTokenRequestSchema: GenMessage<GetIDTokenRequest> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_identity, 0);

/**
 * @generated from message gitpod.v1.GetIDTokenResponse
 */
export type GetIDTokenResponse = Message<"gitpod.v1.GetIDTokenResponse"> & {
  /**
   * @generated from field: string token = 1;
   */
  token: string;
};

/**
 * Describes the message gitpod.v1.GetIDTokenResponse.
 * Use `create(GetIDTokenResponseSchema)` to create a new message.
 */
export const GetIDTokenResponseSchema: GenMessage<GetIDTokenResponse> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_identity, 1);

/**
 * @generated from message gitpod.v1.Subject
 */
export type Subject = Message<"gitpod.v1.Subject"> & {
  /**
   * id is the UUID of the subject
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * Principal is the principal of the subject
   *
   * @generated from field: gitpod.v1.Principal principal = 2;
   */
  principal: Principal;
};

/**
 * Describes the message gitpod.v1.Subject.
 * Use `create(SubjectSchema)` to create a new message.
 */
export const SubjectSchema: GenMessage<Subject> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_identity, 2);

/**
 * @generated from message gitpod.v1.GetAuthenticatedIdentityRequest
 */
export type GetAuthenticatedIdentityRequest = Message<"gitpod.v1.GetAuthenticatedIdentityRequest"> & {
};

/**
 * Describes the message gitpod.v1.GetAuthenticatedIdentityRequest.
 * Use `create(GetAuthenticatedIdentityRequestSchema)` to create a new message.
 */
export const GetAuthenticatedIdentityRequestSchema: GenMessage<GetAuthenticatedIdentityRequest> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_identity, 3);

/**
 * @generated from message gitpod.v1.GetAuthenticatedIdentityResponse
 */
export type GetAuthenticatedIdentityResponse = Message<"gitpod.v1.GetAuthenticatedIdentityResponse"> & {
  /**
   * subject is the identity of the current user
   *
   * @generated from field: gitpod.v1.Subject subject = 1;
   */
  subject?: Subject;

  /**
   * @generated from field: string organization_id = 2;
   */
  organizationId: string;

  /**
   * @generated from field: string organization_tier = 3;
   */
  organizationTier: string;
};

/**
 * Describes the message gitpod.v1.GetAuthenticatedIdentityResponse.
 * Use `create(GetAuthenticatedIdentityResponseSchema)` to create a new message.
 */
export const GetAuthenticatedIdentityResponseSchema: GenMessage<GetAuthenticatedIdentityResponse> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_identity, 4);

/**
 * @generated from message gitpod.v1.ExchangeTokenRequest
 */
export type ExchangeTokenRequest = Message<"gitpod.v1.ExchangeTokenRequest"> & {
  /**
   * exchange_token is the token to exchange
   *
   * @generated from field: string exchange_token = 1;
   */
  exchangeToken: string;
};

/**
 * Describes the message gitpod.v1.ExchangeTokenRequest.
 * Use `create(ExchangeTokenRequestSchema)` to create a new message.
 */
export const ExchangeTokenRequestSchema: GenMessage<ExchangeTokenRequest> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_identity, 5);

/**
 * @generated from message gitpod.v1.ExchangeTokenResponse
 */
export type ExchangeTokenResponse = Message<"gitpod.v1.ExchangeTokenResponse"> & {
  /**
   * access_token is the new access token
   *
   * @generated from field: string access_token = 1;
   */
  accessToken: string;
};

/**
 * Describes the message gitpod.v1.ExchangeTokenResponse.
 * Use `create(ExchangeTokenResponseSchema)` to create a new message.
 */
export const ExchangeTokenResponseSchema: GenMessage<ExchangeTokenResponse> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_identity, 6);

/**
 * @generated from enum gitpod.v1.IDTokenVersion
 */
export enum IDTokenVersion {
  /**
   * When unspecified, the ID token version is 1.
   *
   * @generated from enum value: ID_TOKEN_VERSION_UNSPECIFIED = 0;
   */
  ID_TOKEN_VERSION_UNSPECIFIED = 0,

  /**
   * @generated from enum value: ID_TOKEN_VERSION_V1 = 1;
   */
  ID_TOKEN_VERSION_V1 = 1,

  /**
   * @generated from enum value: ID_TOKEN_VERSION_V2 = 2;
   */
  ID_TOKEN_VERSION_V2 = 2,
}

/**
 * Describes the enum gitpod.v1.IDTokenVersion.
 */
export const IDTokenVersionSchema: GenEnum<IDTokenVersion> = /*@__PURE__*/
  enumDesc(file_gitpod_v1_identity, 0);

/**
 * @generated from enum gitpod.v1.Principal
 */
export enum Principal {
  /**
   * @generated from enum value: PRINCIPAL_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: PRINCIPAL_ACCOUNT = 1;
   */
  ACCOUNT = 1,

  /**
   * @generated from enum value: PRINCIPAL_USER = 2;
   */
  USER = 2,

  /**
   * @generated from enum value: PRINCIPAL_RUNNER = 3;
   */
  RUNNER = 3,

  /**
   * @generated from enum value: PRINCIPAL_ENVIRONMENT = 4;
   */
  ENVIRONMENT = 4,

  /**
   * @generated from enum value: PRINCIPAL_SERVICE_ACCOUNT = 5;
   */
  SERVICE_ACCOUNT = 5,

  /**
   * @generated from enum value: PRINCIPAL_RUNNER_MANAGER = 6;
   */
  RUNNER_MANAGER = 6,
}

/**
 * Describes the enum gitpod.v1.Principal.
 */
export const PrincipalSchema: GenEnum<Principal> = /*@__PURE__*/
  enumDesc(file_gitpod_v1_identity, 1);

/**
 * @generated from service gitpod.v1.IdentityService
 */
export const IdentityService: GenService<{
  /**
   * Gets an ID token for authenticating with other services.
   *
   * Use this method to:
   * - Obtain authentication tokens for service-to-service calls
   * - Access protected resources
   * - Generate scoped access tokens
   *
   * ### Examples
   *
   * - Get token for single service:
   *
   *   Retrieves a token for authenticating with one service.
   *
   *   ```yaml
   *   audience:
   *     - "https://api.gitpod.io"
   *   ```
   *
   * - Get token for multiple services:
   *
   *   Retrieves a token valid for multiple services.
   *
   *   ```yaml
   *   audience:
   *     - "https://api.gitpod.io"
   *     - "https://ws.gitpod.io"
   *   ```
   *
   * @generated from rpc gitpod.v1.IdentityService.GetIDToken
   */
  getIDToken: {
    methodKind: "unary";
    input: typeof GetIDTokenRequestSchema;
    output: typeof GetIDTokenResponseSchema;
  },
  /**
   * Retrieves information about the currently authenticated identity.
   *
   * Use this method to:
   * - Get current user information
   * - Check authentication status
   * - Retrieve organization context
   * - Validate authentication principal
   *
   * ### Examples
   *
   * - Get current identity:
   *
   *   Retrieves details about the authenticated user.
   *
   *   ```yaml
   *   {}
   *   ```
   *
   * @generated from rpc gitpod.v1.IdentityService.GetAuthenticatedIdentity
   */
  getAuthenticatedIdentity: {
    methodKind: "unary";
    input: typeof GetAuthenticatedIdentityRequestSchema;
    output: typeof GetAuthenticatedIdentityResponseSchema;
  },
  /**
   * Exchanges an exchange token for a new access token.
   *
   * Use this method to:
   * - Convert exchange tokens to access tokens
   * - Obtain new access credentials
   * - Complete token exchange flows
   *
   * ### Examples
   *
   * - Exchange token:
   *
   *   Trades an exchange token for an access token.
   *
   *   ```yaml
   *   exchangeToken: "exchange-token-value"
   *   ```
   *
   * @generated from rpc gitpod.v1.IdentityService.ExchangeToken
   */
  exchangeToken: {
    methodKind: "unary";
    input: typeof ExchangeTokenRequestSchema;
    output: typeof ExchangeTokenResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_gitpod_v1_identity, 0);

